module.exports = __webpack_public_path__ + "static/img/ranking-icon.610c8cff.png";